// extracted by mini-css-extract-plugin
export default {"pageSpin":"index_pageSpin__A3mAq","inDisabledLayout":"index_inDisabledLayout__pDpE1"};